var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZhuyi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.37507 10.9894C4.6556 10.9894 3.95705 10.8443 3.29928 10.5586C2.66452 10.2825 2.09355 9.88721 1.60415 9.38447C1.1137 8.88174 0.728866 8.29522 0.460111 7.64316C0.181946 6.96748 0.0407715 6.2499 0.0407715 5.51084C0.0407715 4.77178 0.181946 4.0542 0.460111 3.37852C0.728866 2.72647 1.1137 2.13994 1.6031 1.63721C2.0925 1.1334 2.66348 0.738086 3.29824 0.462012C3.95601 0.17627 4.65456 0.03125 5.37507 0.03125C6.09454 0.03125 6.79309 0.17627 7.45085 0.462012C8.08562 0.738086 8.65659 1.1334 9.14599 1.63613C9.6354 2.13887 10.0202 2.72539 10.289 3.37744C10.5671 4.05313 10.7083 4.7707 10.7083 5.50977C10.7083 6.24883 10.5671 6.96641 10.289 7.64209C10.0202 8.29414 9.6354 8.88066 9.14599 9.3834C8.65659 9.88613 8.08562 10.2814 7.45085 10.5575C6.79309 10.8443 6.09454 10.9894 5.37507 10.9894ZM5.37507 0.847656C2.87262 0.847656 0.836576 2.93916 0.836576 5.50977C0.836576 8.08037 2.87262 10.1719 5.37507 10.1719C7.87752 10.1719 9.91356 8.08037 9.91356 5.50977C9.91356 2.93916 7.87752 0.847656 5.37507 0.847656Z",
    fill: "#FECE1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36466 7.55176C5.14506 7.55176 4.96729 7.36914 4.96729 7.14355V2.37402C4.96729 2.14844 5.14506 1.96582 5.36466 1.96582C5.58427 1.96582 5.76204 2.14844 5.76204 2.37402V7.14355C5.76204 7.36914 5.58427 7.55176 5.36466 7.55176Z",
    fill: "#FECE1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85742 8.64751C4.85742 8.78084 4.90898 8.90872 5.00077 9.003C5.09255 9.09728 5.21703 9.15024 5.34683 9.15024C5.47662 9.15024 5.60111 9.09728 5.69289 9.003C5.78467 8.90872 5.83623 8.78084 5.83623 8.64751C5.83623 8.51418 5.78467 8.3863 5.69289 8.29202C5.60111 8.19774 5.47662 8.14478 5.34683 8.14478C5.21703 8.14478 5.09255 8.19774 5.00077 8.29202C4.90898 8.3863 4.85742 8.51418 4.85742 8.64751Z",
    fill: "#FECE1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.7083,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhuyi);
export default __webpack_public_path__ + "static/media/zhuyi.29d8fb9f321215e7518d7f4f9705d410.svg";
export { ForwardRef as ReactComponent };